import * as action from '../../actions/gdprAdsV3/advertisingOptionsActions';
import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import AdvertisingGdprV3ViewState from '../../store/schema/AdvertisingGdprV3ViewState';
import getAdvertisingOptions from '../../selectors/gdprAdsV3Option/getAdvertisingOptions';
import saveGdprAdsV3OptionOrchestrator from '../../orchestrators/gdprAdsV3/saveAdvertisingOptionOrchestrator';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';
import { VendorList } from '@iabtcf/core';

export const toggleAllStoreAndAccessDeviceMutator = mutator(
    action.toggleAllStoreAndAccessDevice,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allStoreAndAccessDevice = !options.allStoreAndAccessDevice;
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowDevelopAndImproveProductMutator = mutator(
    action.toggleAllowDevelopAndImproveProduct,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowDevelopAndImproveProduct = !options.allowDevelopAndImproveProduct;
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsMutator = mutator(action.toggleAllowPersonalisedAds, () => {
    const options = getAdvertisingOptions();
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.allowPersonalisedAds = !options.allowPersonalisedAds;
    viewState.allowPersonalisedAdsSelectBasicAd = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsApplyMarketResearch = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsMeasureContentPerformance = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsMeasureAdPerf = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsSelectPersonalisedAds = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsSelectPersonalisedContent = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsCreatePersonalisedContentProfile = viewState.allowPersonalisedAds;
    viewState.allowPersonalisedAdsCreatePersonalisedAdsProfile = viewState.allowPersonalisedAds;
    saveGdprAdsV3OptionOrchestrator(store);
});

export const toggleAllowPersonalisedAdsSelectBasicAdMutator = mutator(
    action.toggleAllowPersonalisedAdsSelectBasicAd,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsSelectBasicAd = !options.allowPersonalisedAdsSelectBasicAd;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsSelectBasicAd
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsApplyMarketResearchMutator = mutator(
    action.toggleAllowPersonalisedAdsApplyMarketResearch,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsApplyMarketResearch = !options.allowPersonalisedAdsApplyMarketResearch;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsApplyMarketResearch
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsMeasureContentPerformanceMutator = mutator(
    action.toggleAllowPersonalisedAdsMeasureContentPerformance,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsMeasureContentPerformance = !options.allowPersonalisedAdsMeasureContentPerformance;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsMeasureContentPerformance
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsSelectPersonalisedAdsMutator = mutator(
    action.toggleAllowPersonalisedAdsSelectPersonalisedAds,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsSelectPersonalisedAds = !options.allowPersonalisedAdsSelectPersonalisedAds;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsSelectPersonalisedAds
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsMeasureAdPerfMutator = mutator(
    action.toggleAllowPersonalisedAdsMeasureAdPerf,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsMeasureAdPerf = !options.allowPersonalisedAdsMeasureAdPerf;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsMeasureAdPerf
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsSelectPersonalisedContentMutator = mutator(
    action.toggleAllowPersonalisedAdsSelectPersonalisedContent,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsSelectPersonalisedContent = !options.allowPersonalisedAdsSelectPersonalisedContent;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsSelectPersonalisedContent
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsCreatePersonalisedContentProfileMutator = mutator(
    action.toggleAllowPersonalisedAdsCreatePersonalisedContentProfile,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsCreatePersonalisedContentProfile = !options.allowPersonalisedAdsCreatePersonalisedContentProfile;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsCreatePersonalisedContentProfile
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPersonalisedAdsCreatePersonalisedAdsProfileMutator = mutator(
    action.toggleAllowPersonalisedAdsCreatePersonalisedAdsProfile,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPersonalisedAdsCreatePersonalisedAdsProfile = !options.allowPersonalisedAdsCreatePersonalisedAdsProfile;
        updatePersonalizedAdsSectionToggleConditionIfNeeded(
            viewState.allowPersonalisedAdsCreatePersonalisedAdsProfile
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPreciseGeoDataAndIdentifyDeviceMutator = mutator(
    action.toggleAllowPreciseGeoDataAndIdentifyDevice,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPreciseGeoDataAndIdentifyDevice = !options.allowPreciseGeoDataAndIdentifyDevice;
        viewState.allowPreciseGeoDataAndIdentifyDeviceScanDevice =
            viewState.allowPreciseGeoDataAndIdentifyDevice;
        viewState.allowPreciseGeoDataAndIdentifyDeviceGeoData =
            viewState.allowPreciseGeoDataAndIdentifyDevice;
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPreciseGeoDataAndIdentifyDeviceScanDeviceMutator = mutator(
    action.toggleAllowPreciseGeoDataAndIdentifyDeviceScanDevice,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPreciseGeoDataAndIdentifyDeviceScanDevice = !options.allowPreciseGeoDataAndIdentifyDeviceScanDevice;
        updatePreciseGeoDataAndIdentifyDeviceToggleConditionIfNeeded(
            viewState.allowPreciseGeoDataAndIdentifyDeviceScanDevice
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleAllowPreciseGeoDataAndIdentifyDeviceGeoDataMutator = mutator(
    action.toggleAllowPreciseGeoDataAndIdentifyDeviceGeoData,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.allowPreciseGeoDataAndIdentifyDeviceGeoData = !options.allowPreciseGeoDataAndIdentifyDeviceGeoData;
        updatePreciseGeoDataAndIdentifyDeviceToggleConditionIfNeeded(
            viewState.allowPreciseGeoDataAndIdentifyDeviceGeoData
        );
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleVendorOptionMutator = mutator(action.toggleVendorOption, msg => {
    const options = getAdvertisingOptions();
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.disselectedVendorId = options.disselectedVendorId;
    // Specially handle the null disselectedVendorId situation which means a completely new user
    // We need to add all vendorIds to the disallowed list
    if (viewState.disselectedVendorId == null) {
        diableAllVendors(msg.vendorList);
    }

    if (viewState.disselectedVendorId.indexOf(msg.vendorId) === -1) {
        viewState.disselectedVendorId.push(msg.vendorId);
    } else {
        viewState.disselectedVendorId.splice(
            viewState.disselectedVendorId.indexOf(msg.vendorId),
            1
        );
    }
    saveGdprAdsV3OptionOrchestrator(store);
});

export const toggleLegitimateInterestPurposesOptionMutator = mutator(
    action.toggleLegitimateInterestPurposesOption,
    () => {
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.selectedVendorId = options.selectedVendorId;
        if (viewState.selectedVendorId == null) {
            viewState.selectedVendorId = [];
        }

        if (viewState.selectedVendorId.indexOf(1) > -1) {
            viewState.selectedVendorId = viewState.selectedVendorId.filter(i => i !== 1);
        } else {
            viewState.selectedVendorId.push(1);
        }

        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const toggleFirstPartyCookieOptionMutator = mutator(
    action.toggleFirstPartyCookieOption,
    () => {
        // 2 is on
        // 3 is explicitly off
        // no value is implicitly off
        const options = getAdvertisingOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.selectedVendorId = options.selectedVendorId;
        viewState.selectedVendorId = options.selectedVendorId;

        if (viewState.selectedVendorId == null) {
            viewState.selectedVendorId = [];
        }

        if (viewState.selectedVendorId.indexOf(2) > -1) {
            viewState.selectedVendorId = viewState.selectedVendorId.filter(i => i !== 2);
            viewState.selectedVendorId.push(3);
        } else if (viewState.selectedVendorId.indexOf(3) > -1) {
            viewState.selectedVendorId = viewState.selectedVendorId.filter(i => i !== 3);
            viewState.selectedVendorId.push(2);
        } else {
            viewState.selectedVendorId.push(2);
        }
    }
);

export const setVendorListMutator = mutator(action.setVendorList, msg => {
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.vendorList = msg.vendorList;
});

export const setShownVendorMutator = mutator(action.setShownVendor, msg => {
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.shownedVendor = msg.vendor;
});

export const enableAllVendorsOptionMutator = mutator(action.enableAllVendorsOption, () => {
    const options = getAdvertisingOptions();
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.disselectedVendorId = options.disselectedVendorId;
    if (viewState.disselectedVendorId == null) {
        viewState.disselectedVendorId = [];
    }
    if (viewState.disselectedVendorId.length > 0) {
        viewState.disselectedVendorId.splice(0, viewState.disselectedVendorId.length);
    }
    saveGdprAdsV3OptionOrchestrator(store);
});

export const disableAllVendorsOptionMutator = mutator(action.disableAllVendorsOption, msg => {
    diableAllVendors(msg.vendorList);
});

export const enableAllFeaturesVendorsOptionMutator = mutator(
    action.enableAllFeaturesVendorsOption,
    () => {
        const store = getOptionsStore();
        const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
        viewState.disselectedVendorId = [];
        viewState.selectedVendorId = [2];
        viewState.allStoreAndAccessDevice = true;
        viewState.allowDevelopAndImproveProduct = true;
        viewState.allowPersonalisedAds = true;
        viewState.allowPersonalisedAdsSelectBasicAd = true;
        viewState.allowPersonalisedAdsApplyMarketResearch = true;
        viewState.allowPersonalisedAdsMeasureContentPerformance = true;
        viewState.allowPersonalisedAdsSelectPersonalisedAds = true;
        viewState.allowPersonalisedAdsMeasureAdPerf = true;
        viewState.allowPersonalisedAdsSelectPersonalisedContent = true;
        viewState.allowPersonalisedAdsCreatePersonalisedContentProfile = true;
        viewState.allowPersonalisedAdsCreatePersonalisedAdsProfile = true;
        viewState.allowPreciseGeoDataAndIdentifyDevice = true;
        viewState.allowPreciseGeoDataAndIdentifyDeviceScanDevice = true;
        viewState.allowPreciseGeoDataAndIdentifyDeviceGeoData = true;
        saveGdprAdsV3OptionOrchestrator(store);
    }
);

export const setEmailAdsSelectOptionsMutator = mutator(action.setEmailAdsSelectOptions, msg => {
    // 1 is explicitly opt-off
    // 2 is explicitly opt-in
    // other values are implicitly opt-off
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.optInBit = msg.optInBit;
});

export const loadGdprAdsV3OptionMutator = mutator(action.loadGdprAdsV3Option, () => {
    const options = getAdvertisingOptions();

    // We only show the save button when encodedTCString is null or undefined
    // This gives the first-time user to save the all opt-out setting without any change
    let loadingOnDirty = false;
    if (options == null || options.encodedTCString == null) {
        loadingOnDirty = true;
    }

    getOptionsStore().activeViewState = {
        name: ActiveItem.AdvertisingGdprV3,
        isDirty: loadingOnDirty,
        isLoading: false,
        allStoreAndAccessDevice: options.allStoreAndAccessDevice,
        allowDevelopAndImproveProduct: options.allowDevelopAndImproveProduct,
        allowPersonalisedAds: options.allowPersonalisedAds,
        allowPersonalisedAdsSelectBasicAd: options.allowPersonalisedAdsSelectBasicAd,
        allowPersonalisedAdsApplyMarketResearch: options.allowPersonalisedAdsApplyMarketResearch,
        allowPersonalisedAdsMeasureContentPerformance:
            options.allowPersonalisedAdsMeasureContentPerformance,
        allowPersonalisedAdsSelectPersonalisedAds:
            options.allowPersonalisedAdsSelectPersonalisedAds,
        allowPersonalisedAdsMeasureAdPerf: options.allowPersonalisedAdsMeasureAdPerf,
        allowPersonalisedAdsSelectPersonalisedContent:
            options.allowPersonalisedAdsSelectPersonalisedContent,
        allowPersonalisedAdsCreatePersonalisedContentProfile:
            options.allowPersonalisedAdsCreatePersonalisedContentProfile,
        allowPersonalisedAdsCreatePersonalisedAdsProfile:
            options.allowPersonalisedAdsCreatePersonalisedAdsProfile,
        allowPreciseGeoDataAndIdentifyDevice: options.allowPreciseGeoDataAndIdentifyDevice,
        allowPreciseGeoDataAndIdentifyDeviceScanDevice:
            options.allowPreciseGeoDataAndIdentifyDeviceScanDevice,
        allowPreciseGeoDataAndIdentifyDeviceGeoData:
            options.allowPreciseGeoDataAndIdentifyDeviceGeoData,
        disselectedVendorId: options.disselectedVendorId,
        selectedVendorId: options.selectedVendorId,
        shownedVendor: null,
        vendorList: options.vendorList,
        optInBit: options.optInBit,
    } as ActiveOptionViewState;
});

function diableAllVendors(vendorList: VendorList): void {
    const options = getAdvertisingOptions();
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    viewState.disselectedVendorId = options.disselectedVendorId;
    if (viewState.disselectedVendorId == null) {
        viewState.disselectedVendorId = [];
    }
    const strToInt: (str: string) => number = (str: string): number => parseInt(str, 10);

    const allVendorIds = Object.keys(vendorList.vendors)
        .filter(function (key: string) {
            // Only get the vendorIds without deletedDate
            return vendorList.vendors[key].deletedDate == null;
        })
        .map(strToInt);
    allVendorIds.forEach(vendorId => {
        if (viewState.disselectedVendorId.indexOf(vendorId) === -1) {
            viewState.disselectedVendorId.push(vendorId);
        }
    });
    viewState.isDirty = true;
}

function updatePersonalizedAdsSectionToggleConditionIfNeeded(toggleValueTo: boolean): void {
    // If the value is toggled from true to false, we will always show PersonalizedAds as unchecked
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    if (!toggleValueTo) {
        viewState.allowPersonalisedAds = false;
    } else {
        // If the value is toggled from false to true, we only show allowPersonalisedAds as checked if every option is checked
        const checkedInValues = [
            viewState.allowPersonalisedAdsSelectBasicAd,
            viewState.allowPersonalisedAdsApplyMarketResearch,
            viewState.allowPersonalisedAdsMeasureContentPerformance,
            viewState.allowPersonalisedAdsMeasureAdPerf,
            viewState.allowPersonalisedAdsSelectPersonalisedAds,
            viewState.allowPersonalisedAdsSelectPersonalisedContent,
            viewState.allowPersonalisedAdsCreatePersonalisedContentProfile,
            viewState.allowPersonalisedAdsCreatePersonalisedAdsProfile,
        ];

        if (verifyAllValuesTrue(checkedInValues)) {
            viewState.allowPersonalisedAds = true;
        }
    }
}

function updatePreciseGeoDataAndIdentifyDeviceToggleConditionIfNeeded(
    toggleValueTo: boolean
): void {
    // If the value is toggled from true to false, we will always show allowPreciseGeoDataAndIdentifyDevice as not checked
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;
    if (!toggleValueTo) {
        viewState.allowPreciseGeoDataAndIdentifyDevice = false;
    } else {
        // If the value is toggled from false to true, we only change the allowPreciseGeoDataAndIdentifyDevice toggle as checked if all values are checked
        const checkedInValues = [
            viewState.allowPreciseGeoDataAndIdentifyDeviceScanDevice,
            viewState.allowPreciseGeoDataAndIdentifyDeviceGeoData,
        ];

        if (verifyAllValuesTrue(checkedInValues)) {
            viewState.allowPreciseGeoDataAndIdentifyDevice = true;
        }
    }
}

function verifyAllValuesTrue(array: boolean[]): boolean {
    return array.every(Boolean);
}
